export default "__VITE_ASSET__4UEMwRvh__"